import { z } from "zod";

export const getQuickContactSchema = () => {
  const t =
    (window as any).commonVariables?.translations?.quickContactForm
      ?.validation || {};

  return z.object({
    name: z.string().min(2, t.nameMin || "Name is too short"),
    phone: z.string().min(5, t.phoneMin || "Phone is too short"),
    email: z.string().email(t.emailInvalid || "Invalid email"),
    subject: z.string().optional(),
    message: z.string().min(10, t.messageMin || "Message is too short"),
    nickname: z.string().optional(),
    form_load_timestamp: z.coerce.number(),
  });
};
